export default __webpack_public_path__ + "static/media/checkbox-round-checked.0dd38163.svg";